{
  "+1 day": "+1 day",
  "1 hour": "1 hour",
  "1 hour 15 minutes": "1 hour 15 minutes",
  "1 hour 30 minutes": "1 hour 30 minutes",
  "1 hour 45 minutes": "1 hour 45 minutes",
  "15 minutes": "15 minutes",
  "2 hours": "2 hours",
  "30 minutes": "30 minutes",
  "45 minutes": "45 minutes",
  "A change date is required": "A change date is required",
  "A day holds at most 10 periods": "A day holds at most 10 periods",
  "A new code is on its way.": "A new code is on its way.",
  "A pattern of 2–56 days that repeats, e.g. 2 early, 2 night, 4 off": "A pattern of 2–56 days that repeats, e.g. 2 early, 2 night, 4 off",
  "Absence": "Absence",
  "Absence contact person": "Absence contact person",
  "Absence workflow package": "Absence workflow package",
  "Absences registered for this person appear here.": "Absences registered for this person appear here.",
  "Account frozen": "Account frozen",
  "Account manager": "Account manager",
  "Action list": "Action list",
  "Action plan": "Action plan",
  "Action plan review": "Action plan review",
  "Actions": "Actions",
  "Actions for this version": "Actions for this version",
  "Actions panel": "Actions panel",
  "Activation links expire for your security. Ask your administrator to send a new invitation.": "Activation links expire for your security. Ask your administrator to send a new invitation.",
  "Active": "Active",
  "Active filters": "Active filters",
  "Add": "Add",
  "Add a date": "Add a date",
  "Add a period or choose Off": "Add a period or choose Off",
  "Add period": "Add period",
  "Addition": "Addition",
  "Address": "Address",
  "Address copied": "Address copied",
  "Afternoon": "Afternoon",
  "AGB code": "AGB code",
  "Agenda": "Agenda",
  "All cases": "All cases",
  "Amend": "Amend",
  "An end date is required": "An end date is required",
  "Analysis": "Analysis",
  "Apply": "Apply",
  "Are you still there?": "Are you still there?",
  "Assigned to me": "Assigned to me",
  "Awaiting signature": "Awaiting signature",
  "Back to list": "Back to list",
  "Back to rotation": "Back to rotation",
  "Back to sign in": "Back to sign in",
  "Back to workbench": "Back to workbench",
  "Based on your gender.": "Based on your gender.",
  "Break (min)": "Break (min)",
  "Business phone": "Business phone",
  "Calendar apps using the current link stop updating until you subscribe with the new one.": "Calendar apps using the current link stop updating until you subscribe with the new one.",
  "Calendar link regenerated. Subscribe again with the new link.": "Calendar link regenerated. Subscribe again with the new link.",
  "Calendar subscription": "Calendar subscription",
  "Can't compare with the contract hours: the period is incomplete": "Can't compare with the contract hours: the period is incomplete",
  "Can't scan the code?": "Can't scan the code?",
  "Cancel": "Cancel",
  "Cancelled": "Cancelled",
  "Care team": "Care team",
  "Case manager": "Case manager",
  "Case not found": "Case not found",
  "Cases assigned to you appear here.": "Cases assigned to you appear here.",
  "Cause category": "Cause category",
  "Certainty": "Certainty",
  "Certificate": "Certificate",
  "Certificate actions for {role}": "Certificate actions for {role}",
  "Certificate removed": "Certificate removed",
  "Certificate uploaded": "Certificate uploaded",
  "Chained": "Chained",
  "Change date": "Change date",
  "Change email": "Change email",
  "Change password": "Change password",
  "Change photo": "Change photo",
  "Change theme": "Change theme",
  "Changed on this date only": "Changed on this date only",
  "Changes on single dates are kept.": "Changes on single dates are kept.",
  "Choose a JPEG, PNG or GIF image under 5 MB.": "Choose a JPEG, PNG or GIF image under 5 MB.",
  "Choose a JPEG, PNG or WebP image under 5 MB.": "Choose a JPEG, PNG or WebP image under 5 MB.",
  "Choose a client first": "Choose a client first",
  "Choose a gender": "Choose a gender",
  "Choose your password": "Choose your password",
  "Choose a password you are not using now": "Choose a password you are not using now",
  "Choose a PDF or DOCX under 5 MB.": "Choose a PDF or DOCX under 5 MB.",
  "Choose a start date": "Choose a start date",
  "Choose an employer first": "Choose an employer first",
  "Choose an employment to copy from": "Choose an employment to copy from",
  "Choose the date day 1 falls on": "Choose the date day 1 falls on",
  "Choose the date the roster is filled in up to": "Choose the date the roster is filled in up to",
  "City": "City",
  "Clear": "Clear",
  "Clear filters": "Clear filters",
  "Clear search": "Clear search",
  "Client": "Client",
  "Client not found": "Client not found",
  "Client type": "Client type",
  "Clients": "Clients",
  "Clients you have access to appear here.": "Clients you have access to appear here.",
  "Close": "Close",
  "Closed": "Closed",
  "Collapse sidebar": "Collapse sidebar",
  "Complete the form to see the preview": "Complete the form to see the preview",
  "Completed": "Completed",
  "Completed late": "Completed late",
  "Completed on time": "Completed on time",
  "Confirm new password": "Confirm new password",
  "Confirm your new password": "Confirm your new password",
  "Confirm your password": "Confirm your password",
  "Conflict": "Conflict",
  "Contact": "Contact",
  "Contact information": "Contact information",
  "Contact number": "Contact number",
  "Contract": "Contract",
  "Contract package": "Contract package",
  "Contract type": "Contract type",
  "Copied": "Copied",
  "Copy": "Copy",
  "Copy a work schedule": "Copy a work schedule",
  "Copy address": "Copy address",
  "Copy from another employment": "Copy from another employment",
  "Copy key": "Copy key",
  "Copy link": "Copy link",
  "Correct": "Correct",
  "Correct work schedule": "Correct work schedule",
  "Could not discard the draft. Try again.": "Could not discard the draft. Try again.",
  "Could not load this schedule": "Could not load this schedule",
  "Could not save to file. Try again.": "Could not save to file. Try again.",
  "Could not start the amendment. Try again.": "Could not start the amendment. Try again.",
  "Countries could not be loaded.": "Countries could not be loaded.",
  "Country": "Country",
  "Create schedule": "Create schedule",
  "Current": "Current",
  "Current absence": "Current absence",
  "Current email": "Current email",
  "Current medical opinion": "Current medical opinion",
  "Current password": "Current password",
  "Dark": "Dark",
  "Date of birth": "Date of birth",
  "Day 1 falls on": "Day 1 falls on",
  "Day 1 of the rotation falls on this date": "Day 1 of the rotation falls on this date",
  "Day {n}": "Day {n}",
  "Delete": "Delete",
  "Delete the version starting {date}?": "Delete the version starting {date}?",
  "Delete version": "Delete version",
  "Department": "Department",
  "Department code": "Department code",
  "Department name": "Department name",
  "Department not found": "Department not found",
  "Departments": "Departments",
  "Departments you have access to appear here.": "Departments you have access to appear here.",
  "Details": "Details",
  "Details, contacts and contract appear here.": "Details, contacts and contract appear here.",
  "Details, contacts and division appear here.": "Details, contacts and division appear here.",
  "Details, contacts and employer appear here.": "Details, contacts and employer appear here.",
  "Details, contacts and sector appear here.": "Details, contacts and sector appear here.",
  "Diagnosis category": "Diagnosis category",
  "Discard": "Discard",
  "Discard changes?": "Discard changes?",
  "Discard draft": "Discard draft",
  "Discard this draft?": "Discard this draft?",
  "Discard your changes?": "Discard your changes?",
  "Disease code": "Disease code",
  "Division": "Division",
  "Division code": "Division code",
  "Division name": "Division name",
  "Division not found": "Division not found",
  "Divisions": "Divisions",
  "Divisions you have access to appear here.": "Divisions you have access to appear here.",
  "Documents": "Documents",
  "Documents filed for this person appear here.": "Documents filed for this person appear here.",
  "Dossiers": "Dossiers",
  "Draft": "Draft",
  "Due within 7 days": "Due within 7 days",
  "Earlier": "Earlier",
  "Earlier messages didn’t load.": "Earlier messages didn’t load.",
  "Early": "Early",
  "Email": "Email",
  "Email is required": "Email is required",
  "Employability": "Employability",
  "Employability profile": "Employability profile",
  "Employee": "Employee",
  "Employees": "Employees",
  "Employer": "Employer",
  "Employer not found": "Employer not found",
  "Employers": "Employers",
  "Employers you have access to appear here.": "Employers you have access to appear here.",
  "Employments": "Employments",
  "Employments registered for this person appear here.": "Employments registered for this person appear here.",
  "End": "End",
  "Enter a length from 2 to 56 days": "Enter a length from 2 to 56 days",
  "Enter a new password": "Enter a new password",
  "Enter a time like 08:00": "Enter a time like 08:00",
  "Enter a valid email address": "Enter a valid email address",
  "Enter both ends of the range": "Enter both ends of the range",
  "Enter hours between 0 and 24, like 7,5 or 7:30": "Enter hours between 0 and 24, like 7,5 or 7:30",
  "Enter the 6-digit code we sent to {email}.": "Enter the 6-digit code we sent to {email}.",
  "Enter the break in whole minutes": "Enter the break in whole minutes",
  "Enter the six-digit code": "Enter the six-digit code",
  "Enter the six-digit code from your authenticator app": "Enter the six-digit code from your authenticator app",
  "Enter the six-digit code from your authenticator app.": "Enter the six-digit code from your authenticator app.",
  "Enter this key into your authenticator app or password manager:": "Enter this key into your authenticator app or password manager:",
  "Enter your credentials to continue.": "Enter your credentials to continue.",
  "Enter your current password": "Enter your current password",
  "Enter your last name": "Enter your last name",
  "Events recorded for this person appear here.": "Events recorded for this person appear here.",
  "Everyone in your scope, with or without an open case.": "Everyone in your scope, with or without an open case.",
  "Exception": "Exception",
  "Expand sidebar": "Expand sidebar",
  "Expires": "Expires",
  "Female": "Female",
  "Fill the roster in up to a date on or after its start": "Fill the roster in up to a date on or after its start",
  "Filled in up to": "Filled in up to",
  "Filters": "Filters",
  "Final evaluation": "Final evaluation",
  "First name": "First name",
  "First-year evaluation": "First-year evaluation",
  "Fix the errors to update the preview": "Fix the errors to update the preview",
  "Fixed week": "Fixed week",
  "Focus mode": "Focus mode",
  "From": "From",
  "From the fixed week": "From the fixed week",
  "From the rotation (day {day})": "From the rotation (day {day})",
  "From {date}: unknown": "From {date}: unknown",
  "Gender": "Gender",
  "General": "General",
  "General information": "General information",
  "Go to dashboard": "Go to dashboard",
  "HSE contact person": "HSE contact person",
  "Hide actions": "Hide actions",
  "Hide list": "Hide list",
  "Hours": "Hours",
  "House number": "House number",
  "How long you can be inactive before you are signed out automatically.": "How long you can be inactive before you are signed out automatically.",
  "Idle timeout": "Idle timeout",
  "Idle timeout saved": "Idle timeout saved",
  "If an account exists with that email address, you will receive a password reset link shortly.": "If an account exists with that email address, you will receive a password reset link shortly.",
  "Include a lowercase letter": "Include a lowercase letter",
  "Include a number": "Include a number",
  "Include a symbol": "Include a symbol",
  "Include an uppercase letter": "Include an uppercase letter",
  "Incomplete": "Incomplete",
  "Initials": "Initials",
  "Issued": "Issued",
  "Issuing authority": "Issuing authority",
  "It becomes part of the medical file. You can amend it later; this version stays readable.": "It becomes part of the medical file. You can amend it later; this version stays readable.",
  "It may have been removed, or you may not have access to it.": "It may have been removed, or you may not have access to it.",
  "Job description": "Job description",
  "Keep editing": "Keep editing",
  "Keep the label under 50 characters": "Keep the label under 50 characters",
  "Keep this page open until the application starts.": "Keep this page open until the application starts.",
  "Label": "Label",
  "Labour expert assessment": "Labour expert assessment",
  "Last day of absence": "Last day of absence",
  "Last name": "Last name",
  "Late": "Late",
  "Length in days": "Length in days",
  "License number": "License number",
  "Light": "Light",
  "Load earlier": "Load earlier",
  "Load more": "Load more",
  "Loading…": "Loading…",
  "Log out": "Log out",
  "Looking up address…": "Looking up address…",
  "Main contact person": "Main contact person",
  "Male": "Male",
  "Manual": "Manual",
  "Medical file": "Medical file",
  "Middle name": "Middle name",
  "Migrated": "Migrated",
  "Milestone": "Milestone",
  "Mobile number": "Mobile number",
  "Mobile phone": "Mobile phone",
  "Month total": "Month total",
  "More actions": "More actions",
  "More conversations didn’t load.": "More conversations didn’t load.",
  "Morning": "Morning",
  "My caseload": "My caseload",
  "My work": "My work",
  "NCVB category": "NCVB category",
  "Name": "Name",
  "Needs review": "Needs review",
  "New absence percentage": "New absence percentage",
  "New email": "New email",
  "New items appear here as deadlines approach.": "New items appear here as deadlines approach.",
  "New password": "New password",
  "New schedule from…": "New schedule from…",
  "New work schedule": "New work schedule",
  "Next": "Next",
  "Next month": "Next month",
  "Next obligation": "Next obligation",
  "Night": "Night",
  "No open case": "No open case",
  "No open dossier": "No open dossier",
  "No persons in your scope": "No persons in your scope",
  "No roles assigned yet": "No roles assigned yet",
  "No schedule applies to these dates any more.": "No schedule applies to these dates any more.",
  "No WVP workflow": "No WVP workflow",
  "No WVP workflow assigned": "No WVP workflow assigned",
  "No absences recorded": "No absences recorded",
  "No care team assigned": "No care team assigned",
  "No cases yet": "No cases yet",
  "No clients yet": "No clients yet",
  "No clinical details recorded for the current absence.": "No clinical details recorded for the current absence.",
  "No consultation notes yet": "No consultation notes yet",
  "No current work schedule": "No current work schedule",
  "No departments yet": "No departments yet",
  "No divisions yet": "No divisions yet",
  "No documents yet": "No documents yet",
  "Persons": "Persons",
  "Search by name or email…": "Search by name or email…",
  "Sex": "Sex",
  "Showing documents named “{name}”": "Showing documents named “{name}”",
  "Show all": "Show all",
  "Medical documents": "Medical documents",
  "No medical documents": "No medical documents",
  "Medical documents filed for this person appear here.": "Medical documents filed for this person appear here.",
  "No employers yet": "No employers yet",
  "No employments recorded": "No employments recorded",
  "No open obligation": "No open obligation",
  "No results": "No results",
  "No results found.": "No results found.",
  "No work schedule": "No work schedule",
  "No work schedule yet": "No work schedule yet",
  "Not applicable": "Not applicable",
  "Not assessed": "Not assessed",
  "Not available yet": "Not available yet",
  "Not monitored": "Not monitored",
  "Not visible to the employer or to a process casemanager": "Not visible to the employer or to a process casemanager",
  "Not verified": "Not verified",
  "Notes": "Notes",
  "Notes written during a consultation appear here.": "Notes written during a consultation appear here.",
  "Nothing has happened yet": "Nothing has happened yet",
  "Nothing is open": "Nothing is open",
  "Nothing matches these filters.": "Nothing matches these filters.",
  "Nothing matches your search.": "Nothing matches your search.",
  "Notifications": "Notifications",
  "OHP": "OHP",
  "Occupational physician": "Occupational physician",
  "Off": "Off",
  "Ongoing": "Ongoing",
  "Only repeating schedules can be copied": "Only repeating schedules can be copied",
  "Open": "Open",
  "Open in authenticator app": "Open in authenticator app",
  "Open user menu": "Open user menu",
  "Opening the ORL application…": "Opening the ORL application…",
  "Options could not be loaded.": "Options could not be loaded.",
  "Organisation": "Organisation",
  "Other devices are signed out when you change it.": "Other devices are signed out when you change it.",
  "Outside the employment": "Outside the employment",
  "Overdue": "Overdue",
  "Overview": "Overview",
  "POB": "POB",
  "Page not found": "Page not found",
  "Pages": "Pages",
  "Part-time": "Part-time",
  "Partial recovery": "Partial recovery",
  "Password changed. Other devices have been signed out.": "Password changed. Other devices have been signed out.",
  "Password is required": "Password is required",
  "Passwords do not match": "Passwords do not match",
  "People": "People",
  "Period": "Period",
  "Period {n}": "Period {n}",
  "Photo removed": "Photo removed",
  "Photo updated": "Photo updated",
  "Pick something you have not used before.": "Pick something you have not used before.",
  "Pick the right entry": "Pick the right entry",
  "Poortwachter milestones": "Poortwachter milestones",
  "Postal address": "Postal address",
  "Postal code": "Postal code",
  "Powered by": "Powered by",
  "Prefix": "Prefix",
  "Recent": "Recent",
  "Search is unavailable right now": "Search is unavailable right now",
  "Searching…": "Searching…",
  "Untitled": "Untitled",
  "present": "Present",
  "Preview of this version": "Preview of this version",
  "Previous": "Previous",
  "Previous month": "Previous month",
  "Problem analysis": "Problem analysis",
  "Professional": "Professional",
  "Professional Portal": "Professional Portal",
  "Profile": "Profile",
  "Profile saved": "Profile saved",
  "QR code for setting up two-factor authentication": "QR code for setting up two-factor authentication",
  "Qualifications": "Qualifications",
  "Quick actions": "Quick actions",
  "Reason for the correction": "Reason for the correction",
  "Recovered": "Recovered",
  "Reference": "Reference",
  "Regenerate": "Regenerate",
  "Regenerate calendar link?": "Regenerate calendar link?",
  "Regenerate link": "Regenerate link",
  "Regenerating…": "Regenerating…",
  "Register": "Register",
  "Register partial recovery": "Register partial recovery",
  "Register recovery": "Register recovery",
  "Registering…": "Registering…",
  "Registration number": "Registration number",
  "Advice": "Advice",
  "Released advice": "Released advice",
  "Released to the employer": "Released to the employer",
  "Released to the employee": "Released to the employee",
  "Released to the employer and the employee": "Released to the employer and the employee",
  "Reload": "Reload",
  "Remove": "Remove",
  "Remove certificate?": "Remove certificate?",
  "Remove date": "Remove date",
  "Remove days": "Remove days",
  "Remove days {from} to {to}?": "Remove days {from} to {to}?",
  "Remove filter {label}": "Remove filter {label}",
  "Remove period": "Remove period",
  "Remove photo?": "Remove photo?",
  "Remove signature?": "Remove signature?",
  "Replace": "Replace",
  "Report partial": "Report partial",
  "Report recovery": "Report recovery",
  "Report the date the percentage changed and what it changed to.": "Report the date the percentage changed and what it changed to.",
  "Report the last day of this absence.": "Report the last day of this absence.",
  "Reported": "Reported",
  "Resend code": "Resend code",
  "Resend in {seconds}s": "Resend in {seconds}s",
  "Reset your password": "Reset your password",
  "Resize actions panel": "Resize actions panel",
  "Retry": "Retry",
  "Role": "Role",
  "Roles your administrator assigns to you appear here.": "Roles your administrator assigns to you appear here.",
  "Roster": "Roster",
  "Rotation": "Rotation",
  "Rotation of {days} days": "Rotation of {days} days",
  "Rows per page": "Rows per page",
  "Salutation": "Salutation",
  "Save": "Save",
  "Save new password": "Save new password",
  "Save this note to the file?": "Save this note to the file?",
  "Save to file": "Save to file",
  "Saved to file {time}": "Saved to file {time}",
  "Saving…": "Saving…",
  "Say why you are correcting this version": "Say why you are correcting this version",
  "Scan this code with your authenticator app, then enter the six-digit code it shows.": "Scan this code with your authenticator app, then enter the six-digit code it shows.",
  "Scheduled {scheduled}h a week on average, contract {expected}h a week": "Scheduled {scheduled}h a week on average, contract {expected}h a week",
  "Search": "Search",
  "Search cases…": "Search cases…",
  "Search clients…": "Search clients…",
  "Search departments…": "Search departments…",
  "Search divisions…": "Search divisions…",
  "Search employers…": "Search employers…",
  "Search…": "Search…",
  "Second track start": "Second track start",
  "Sector": "Sector",
  "Select a case": "Select a case",
  "Select a client": "Select a client",
  "Select a department": "Select a department",
  "Select a division": "Select a division",
  "Select an employer": "Select an employer",
  "Selected · not on this page": "Selected · not on this page",
  "Send code": "Send code",
  "Send email": "Send email",
  "Send reset link": "Send reset link",
  "Sending…": "Sending…",
  "Set by your administrator.": "Set by your administrator.",
  "Set your password": "Set your password",
  "Settings": "Settings",
  "Shifts on actual dates, filled in as they are known": "Shifts on actual dates, filled in as they are known",
  "Shortening the rotation removes days that hold shifts.": "Shortening the rotation removes days that hold shifts.",
  "Show list": "Show list",
  "Sick report": "Sick report",
  "Sign out after": "Sign out after",
  "Sign out now": "Sign out now",
  "Sign out?": "Sign out?",
  "Signature": "Signature",
  "Signature actions for {role}": "Signature actions for {role}",
  "Signature rejected": "Signature rejected",
  "Signature removed": "Signature removed",
  "Signature uploaded": "Signature uploaded",
  "Signing in…": "Signing in…",
  "Something went wrong": "Something went wrong",
  "Standby": "Standby",
  "Standby {hours}h": "Standby {hours}h",
  "Start": "Start",
  "Start consultation": "Start consultation",
  "Start of employment": "Start of employment",
  "Start on or after {date}": "Start on or after {date}",
  "Start on or before {date}, when the employment ends": "Start on or before {date}, when the employment ends",
  "Starts on": "Starts on",
  "State or province": "State or province",
  "Stay signed in": "Stay signed in",
  "Street": "Street",
  "Street 2": "Street 2",
  "Subscribe to your agenda in Apple Calendar, Google Calendar or Outlook.": "Subscribe to your agenda in Apple Calendar, Google Calendar or Outlook.",
  "Subscription link": "Subscription link",
  "Suffix": "Suffix",
  "Superseded": "Superseded",
  "Supervisor": "Supervisor",
  "Switch employment": "Switch employment",
  "Switch language to Dutch": "Switch language to Dutch",
  "Switch language to English": "Switch language to English",
  "System": "System",
  "That code could not be verified. Please try again.": "That code could not be verified. Please try again.",
  "The draft is deleted. This cannot be undone.": "The draft is deleted. This cannot be undone.",
  "The file is deleted from your profile. You can upload a new one at any time.": "The file is deleted from your profile. You can upload a new one at any time.",
  "The ORL application should open automatically.": "The ORL application should open automatically.",
  "The break must be shorter than the period": "The break must be shorter than the period",
  "The chosen employment’s repeating schedule starts here on this date.": "The chosen employment’s repeating schedule starts here on this date.",
  "The dossier appears here.": "The dossier appears here.",
  "The list shows only what matches every filter.": "The list shows only what matches every filter.",
  "The migrated schedule has conflicts that need correcting": "The migrated schedule has conflicts that need correcting",
  "The previous version runs on in its place.": "The previous version runs on in its place.",
  "The same seven days every week": "The same seven days every week",
  "The work schedule entered for this employment appears here.": "The work schedule entered for this employment appears here.",
  "The work schedule was changed by someone else. Reload it and try again.": "The work schedule was changed by someone else. Reload it and try again.",
  "The work schedule was reloaded. Enter your changes again on the current version.": "The work schedule was reloaded. Enter your changes again on the current version.",
  "There is already a version starting {date}. Correct or delete it to change the schedule before then.": "There is already a version starting {date}. Correct or delete it to change the schedule before then.",
  "This absence changed while you were filling this in. Reload to see it.": "This absence changed while you were filling this in. Reload to see it.",
  "This case": "This case",
  "This date": "This date",
  "This date is outside the roster": "This date is outside the roster",
  "This link is no longer valid": "This link is no longer valid",
  "This list isn't available": "This list isn't available",
  "This month": "This month",
  "This page is not available yet.": "This page is not available yet.",
  "This part of the dossier arrives in a later release.": "This part of the dossier arrives in a later release.",
  "This part of the dossier is no longer available to you": "This part of the dossier is no longer available to you",
  "This version or date no longer exists. The schedule was reloaded.": "This version or date no longer exists. The schedule was reloaded.",
  "Timeline": "Timeline",
  "Times": "Times",
  "Title": "Title",
  "To": "To",
  "Too many attempts. Please wait a minute and try again.": "Too many attempts. Please wait a minute and try again.",
  "Try again": "Try again",
  "Two-factor authentication": "Two-factor authentication",
  "Type to search…": "Type to search…",
  "Unassigned": "Unassigned",
  "Unknown": "Unknown",
  "Unknown author": "Unknown author",
  "Unknown employer": "Unknown employer",
  "Untitled document": "Untitled document",
  "Upcoming": "Upcoming",
  "Upload": "Upload",
  "Upload certificate for {role}": "Upload certificate for {role}",
  "Upload signature for {role}": "Upload signature for {role}",
  "Use a different email": "Use a different email",
  "Use a percentage between 1 and 100": "Use a percentage between 1 and 100",
  "Use a whole percentage": "Use a whole percentage",
  "Use at least 12 characters": "Use at least 12 characters",
  "Use at least 6 characters": "Use at least 6 characters",
  "Use at least 8 characters": "Use at least 8 characters",
  "Use at most 10 characters": "Use at most 10 characters",
  "Use at most 100 characters": "Use at most 100 characters",
  "Use at most 16 characters": "Use at most 16 characters",
  "Use at most 20 characters": "Use at most 20 characters",
  "Use at most 50 characters": "Use at most 50 characters",
  "Variable roster": "Variable roster",
  "Verification code": "Verification code",
  "Verified": "Verified",
  "Verify": "Verify",
  "Verifying your email…": "Verifying your email…",
  "Verifying…": "Verifying…",
  "Version deleted": "Version deleted",
  "Versions": "Versions",
  "View": "View",
  "View certificate for {role}": "View certificate for {role}",
  "View signature for {role}": "View signature for {role}",
  "Visible to you and to administrators.": "Visible to you and to administrators.",
  "Visiting address": "Visiting address",
  "We could not upload this file. Please try again.": "We could not upload this file. Please try again.",
  "WIA application": "WIA application",
  "Waiting on an employer": "Waiting on an employer",
  "We could not change your password. Please try again.": "We could not change your password. Please try again.",
  "We could not open the ORL application.": "We could not open the ORL application.",
  "We could not regenerate the calendar link. Please try again.": "We could not regenerate the calendar link. Please try again.",
  "We could not register the recovery. Please try again.": "We could not register the recovery. Please try again.",
  "We could not reset your password. Please try again.": "We could not reset your password. Please try again.",
  "We could not save the work schedule. Please try again.": "We could not save the work schedule. Please try again.",
  "We could not save your idle timeout. Please try again.": "We could not save your idle timeout. Please try again.",
  "We could not save your profile. Please try again.": "We could not save your profile. Please try again.",
  "We could not send the link. Please try again.": "We could not send the link. Please try again.",
  "We could not sign you in. Please try again.": "We could not sign you in. Please try again.",
  "We could not start the email change. Please try again.": "We could not start the email change. Please try again.",
  "We could not update your photo. Please try again.": "We could not update your photo. Please try again.",
  "We send a code to the new address. The change applies once you enter it, and signs you out everywhere.": "We send a code to the new address. The change applies once you enter it, and signs you out everywhere.",
  "We will email you a link to choose a new password.": "We will email you a link to choose a new password.",
  "Website": "Website",
  "Week": "Week",
  "Week 42 UWV report": "Week 42 UWV report",
  "Week total": "Week total",
  "Week {n}": "Week {n}",
  "What kind of schedule?": "What kind of schedule?",
  "What this day is": "What this day is",
  "What you entered is not saved.": "What you entered is not saved.",
  "Which cases": "Which cases",
  "Work": "Work",
  "Work aspects": "Work aspects",
  "Work hours": "Work hours",
  "Work number": "Work number",
  "Work queue": "Work queue",
  "Work schedule": "Work schedule",
  "Work schedule saved": "Work schedule saved",
  "Workbench": "Workbench",
  "Workbench opens on": "Workbench opens on",
  "Which view the Workbench shows when you open it.": "Which view the Workbench shows when you open it.",
  "Default for my role ({home})": "Default for my role ({home})",
  "Queue": "Queue",
  "Consultations": "Consultations",
  "Workbench preference saved": "Workbench preference saved",
  "We could not save your Workbench preference. Please try again.": "We could not save your Workbench preference. Please try again.",
  "Workday": "Workday",
  "You already have a draft for this consult. It is open in the note editor.": "You already have a draft for this consult. It is open in the note editor.",
  "You are signed in": "You are signed in",
  "You don't have access to clients": "You don't have access to clients",
  "You don't have access to departments": "You don't have access to departments",
  "You don't have access to divisions": "You don't have access to divisions",
  "You don't have access to employers": "You don't have access to employers",
  "You don't have access to persons": "You don't have access to persons",
  "You don't have access to the caseload": "You don't have access to the caseload",
  "You don't have access to the work queue": "You don't have access to the work queue",
  "You don't have access to this client": "You don't have access to this client",
  "You don't have access to this department": "You don't have access to this department",
  "You don't have access to this division": "You don't have access to this division",
  "You don't have access to this employer": "You don't have access to this employer",
  "You don't have access to this list": "You don't have access to this list",
  "You don't have access to this person's file": "You don't have access to this person's file",
  "You don't have access to this work schedule": "You don't have access to this work schedule",
  "You have been inactive for a while. To protect patient data, you will be signed out in {time}.": "You have been inactive for a while. To protect patient data, you will be signed out in {time}.",
  "You have been signed out in another tab.": "You have been signed out in another tab.",
  "You were signed out because you were inactive.": "You were signed out because you were inactive.",
  "You will be signed out in {time}.": "You will be signed out in {time}.",
  "You will need to sign in again to continue.": "You will need to sign in again to continue.",
  "Your access changed while this page was open.": "Your access changed while this page was open.",
  "Your account has been frozen. Please contact an administrator.": "Your account has been frozen. Please contact an administrator.",
  "Your account is active. The next step is to set your password.": "Your account is active. The next step is to set your password.",
  "Your address and phone numbers.": "Your address and phone numbers.",
  "Your changes on this tab have not been saved.": "Your changes on this tab have not been saved.",
  "Your email address has changed. Sign in with your new address.": "Your email address has changed. Sign in with your new address.",
  "Your initials will be shown instead.": "Your initials will be shown instead.",
  "Your name and gender.": "Your name and gender.",
  "Your organisation allows at most {minutes} minutes.": "Your organisation allows at most {minutes} minutes.",
  "Your session has expired. Please sign in again.": "Your session has expired. Please sign in again.",
  "Your sign-in timed out. Please sign in again.": "Your sign-in timed out. Please sign in again.",
  "Your unsaved changes were discarded.": "Your unsaved changes were discarded.",
  "ends the next day": "ends the next day",
  "wk {week}/{total}": "wk {week}/{total}",
  "{count} day in conflict | {count} days in conflict": "{count} day in conflict | {count} days in conflict",
  "{count} unknown day | {count} unknown days": "{count} unknown day | {count} unknown days",
  "{count} unread notifications": "{count} unread notification | {count} unread notifications",
  "{date}: off": "{date}: off",
  "{from} – {to}: off": "{from} – {to}: off",
  "{from}–{to} of {total}": "{from}–{to} of {total}",
  "{hours}h": "{hours}h",
  "{hours}h standby": "{hours}h standby",
  "{hours}h work": "{hours}h work",
  "{percentage}% employable": "{percentage}% employable",
  "Reasoned deviation": "Reasoned deviation",
  "Long-term absence apparent later": "Long-term absence apparent later",
  "No exploitable possibilities": "No exploitable possibilities",
  "Marginal possibilities": "Marginal possibilities",
  "Concrete return prospect in the own organisation": "Concrete return prospect in the own organisation",
  "Return to own work expected": "Return to own work expected",
  "Structural return realised": "Structural return realised",
  "AOW age within one year": "AOW age within one year",
  "Employer and employee": "Employer and employee",
  "Record exception": "Record exception",
  "Withdraw exception": "Withdraw exception",
  "Add note": "Add note",
  "Save note": "Save note",
  "Reason": "Reason",
  "Choose a reason": "Choose a reason",
  "Note": "Note",
  "Due": "Due",
  "Back": "Back",
  "(optional)": "(optional)",
  "Date the employee agreed": "Date the employee agreed",
  "Decided by": "Decided by",
  "Decided by UWV": "Decided by UWV",
  "Recorded by": "Recorded by",
  "Why are you withdrawing this?": "Why are you withdrawing this?",
  "The obligation returns to whatever its schedule says, and may show as overdue.": "The obligation returns to whatever its schedule says, and may show as overdue.",
  "The obligations return to whatever the schedule says, and may show as overdue.": "The obligations return to whatever the schedule says, and may show as overdue.",
  "This note is not a medical record. Do not include a diagnosis, cause, treatment or vangnet status. Clinical reasoning belongs in the encounter note.": "This note is not a medical record. Do not include a diagnosis, cause, treatment or vangnet status. Clinical reasoning belongs in the encounter note.",
  "Record the date the employee agreed": "Record the date the employee agreed",
  "The employee cannot have agreed in the future": "The employee cannot have agreed in the future",
  "Say why you are withdrawing this exception": "Say why you are withdrawing this exception",
  "Write the note": "Write the note",
  "Keep the note under 2000 characters": "Keep the note under 2000 characters",
  "Keep the reason under 500 characters": "Keep the reason under 500 characters",
  "Early IVA awarded": "Early IVA awarded",
  "Voluntary extension": "Voluntary extension",
  "Loonsanctie": "Loonsanctie",
  "Employment ended": "Employment ended",
  "UWV": "UWV",
  "UWV decisions": "UWV decisions",
  "No UWV decisions recorded": "No UWV decisions recorded",
  "Record a UWV decision": "Record a UWV decision",
  "Waiting period ends": "Waiting period ends",
  "Decided on": "Decided on",
  "Takes effect": "Takes effect",
  "End date": "End date",
  "Repair reported": "Repair reported",
  "Repair accepted": "Repair accepted",
  "Withdraw": "Withdraw",
  "Edit": "Edit",
  "This replaces the current record. Both are kept.": "This replaces the current record. Both are kept.",
  "Record the date on the decision": "Record the date on the decision",
  "UWV cannot have decided in the future": "UWV cannot have decided in the future",
  "Record the end date on the decision": "Record the end date on the decision",
  "Record the date the award takes effect": "Record the date the award takes effect",
  "Say why you are withdrawing this record": "Say why you are withdrawing this record",
  "Pick a date": "Pick a date",
  "Clear date": "Clear date",
  "This list could not be refreshed": "This list could not be refreshed",
  "You are seeing what was loaded before.": "You are seeing what was loaded before.",
  "Refreshing": "Refreshing",
  "since {date}": "since {date}",
  "item overdue | items overdue": "item overdue | items overdue",
  "item due within 7 days | items due within 7 days": "item due within 7 days | items due within 7 days",
  "task waiting on an employer | tasks waiting on an employer": "task waiting on an employer | tasks waiting on an employer",
  "{count} d": "{count} d",
  "No deadline": "No deadline",
  "Labour expert": "Labour expert",
  "Reintegration company": "Reintegration company",
  "Other": "Other",
  "{count} case without a WVP workflow | {count} cases without a WVP workflow": "{count} case without a WVP workflow | {count} cases without a WVP workflow",
  "Show in My caseload": "Show in My caseload",
  "Appointment": "Appointment",
  "All day": "All day",
  "Done": "Done",
  "No-show": "No-show",
  "{count} min": "{count} min",
  "Today": "Today",
  "No appointments today": "No appointments today",
  "You don't have access to your appointments": "You don't have access to your appointments",
  "{count} appointment | {count} appointments": "{count} appointment | {count} appointments",
  "Tasks": "Tasks",
  "Activities": "Activities",
  "Invoiced": "Invoiced",
  "Halted": "Halted",
  "Executed": "Executed",
  "Deleted": "Deleted",
  "Paid": "Paid",
  "Waiting on {party}": "Waiting on {party}",
  "Everyone": "Everyone",
  "Add filter": "Add filter",
  "Form {done}/{total}": "Form {done}/{total}",
  "Survey": "Survey",
  "Document": "Document",
  "No open items": "No open items",
  "No open activities": "No open activities",
  "No invoiced items": "No invoiced items",
  "Invoiced items are read-only": "Invoiced items are read-only",
  "You don't have access to the action list": "You don't have access to the action list",
  "Category": "Category",
  "Assignee {id}": "Assignee {id}",
  "On time": "On time",
  "Activity": "Activity",
  "Consult mode": "Consult mode",
  "Encounter note": "Encounter note",
  "Awaiting approval": "Awaiting approval",
  "{count}d": "{count}d",
  "{count} day old | {count} days old": "{count} day old | {count} days old",
  "by {name}": "by {name}",
  "Task": "Task",
  "Task delegation": "Task delegation",
  "To finish": "To finish",
  "oldest first": "oldest first",
  "{count} item to finish | {count} items to finish": "{count} item to finish | {count} items to finish",
  "Nothing to finish": "Nothing to finish",
  "You don't have access to your unfinished work": "You don't have access to your unfinished work",
  "Requests": "Requests",
  "asked of you": "asked of you",
  "{count} request | {count} requests": "{count} request | {count} requests",
  "No requests": "No requests",
  "You don't have access to your requests": "You don't have access to your requests",
  "{count} employer update | {count} employer updates": "{count} employer update | {count} employer updates",
  "{count} notification | {count} notifications": "{count} notification | {count} notifications",
  "First contact": "First contact",
  "New since {date}: {changes}": "New since {date}: {changes}",
  "Nothing new since {date}": "Nothing new since {date}",
  "consultation today | consultations today": "consultation today | consultations today",
  "to finish": "to finish",
  "request for you | requests for you": "request for you | requests for you",
  "Findings, workload, agreements…": "Findings, workload, agreements…",
  "Consult date": "Consult date",
  "Medical: only you see this draft": "Medical: only you see this draft",
  "Saved {time}": "Saved {time}",
  "Not saved yet": "Not saved yet",
  "Offline. Your text is kept here and saved when the connection returns.": "Offline. Your text is kept here and saved when the connection returns.",
  "This draft was changed in another window at {time}": "This draft was changed in another window at {time}",
  "Use that version": "Use that version",
  "Keep mine": "Keep mine",
  "This draft no longer exists. It was finalised or deleted in another window.": "This draft no longer exists. It was finalised or deleted in another window.",
  "Save as a new draft": "Save as a new draft",
  "Replace your text?": "Replace your text?",
  "What you typed here is replaced by the version from the other window.": "What you typed here is replaced by the version from the other window.",
  "Your note could not be loaded.": "Your note could not be loaded.",
  "Good morning": "Good morning",
  "Good afternoon": "Good afternoon",
  "Good evening": "Good evening",
  "Good morning, {name}": "Good morning, {name}",
  "Good afternoon, {name}": "Good afternoon, {name}",
  "Good evening, {name}": "Good evening, {name}",
  "Describe what was done": "Describe what was done",
  "Task completed": "Task completed",
  "You can't complete this task.": "You can't complete this task.",
  "This task is no longer open.": "This task is no longer open.",
  "We could not load this task. Please try again.": "We could not load this task. Please try again.",
  "What was done": "What was done",
  "Execute": "Execute",
  "Complete this task in the previous portal.": "Complete this task in the previous portal.",
  "Open in the previous portal": "Open in the previous portal",
  "This certificate is signed and can no longer be changed.": "This certificate is signed and can no longer be changed.",
  "Complete task": "Complete task",
  "Draft saved": "Draft saved",
  "Form completed": "Form completed",
  "Save draft": "Save draft",
  "Optional": "Optional",
  "Form": "Form",
  "Forms in this task": "Forms in this task",
  "Save your changes first?": "Save your changes first?",
  "Complete form": "Complete form",
  "Generate forms": "Generate forms",
  "Generate forms from this note": "Generate forms from this note",
  "Scribe fills the forms of the task you choose with this note. You review the drafts before anything is final.": "Scribe fills the forms of the task you choose with this note. You review the drafts before anything is final.",
  "Choose a task": "Choose a task",
  "No form tasks on this case": "No form tasks on this case",
  "Could not load the form tasks.": "Could not load the form tasks.",
  "Generate": "Generate",
  "Queued": "Queued",
  "Generating": "Generating",
  "Ready: {count} forms": "Ready: {count} forms",
  "Failed": "Failed",
  "AI drafts generated": "AI drafts generated",
  "Review them in the Action list": "Review them in the Action list",
  "Still generating. Check the Action list later.": "Still generating. Check the Action list later.",
  "You can't generate forms for this task": "You can't generate forms for this task",
  "Advice released": "Advice released",
  "Both": "Both",
  "Release": "Release",
  "Release as advice": "Release as advice",
  "The document is recorded as released advice. The encounter note itself never leaves the practice.": "The document is recorded as released advice. The encounter note itself never leaves the practice.",
  "We could not record this. Please try again.": "We could not record this. Please try again.",
  "Who receives this advice?": "Who receives this advice?",
  "You can't release this document": "You can't release this document",
  "Cancel task": "Cancel task",
  "Change task owner": "Change task owner",
  "Cancel activity": "Cancel activity",
  "Mark as no-show": "Mark as no-show",
  "Cancel this task?": "Cancel this task?",
  "Cancel this activity?": "Cancel this activity?",
  "Mark this activity as no-show?": "Mark this activity as no-show?",
  "All its open tasks are cancelled.": "All its open tasks are cancelled.",
  "All its open tasks are marked as no-show.": "All its open tasks are marked as no-show.",
  "This ends the activity. You can record why.": "This ends the activity. You can record why.",
  "No reason": "No reason",
  "Explanation": "Explanation",
  "Too early": "Too early",
  "Too late": "Too late",
  "Wrong location": "Wrong location",
  "Wrong professional": "Wrong professional",
  "Patient unavailable": "Patient unavailable",
  "Say why you are cancelling": "Say why you are cancelling",
  "Keep the explanation under 500 characters": "Keep the explanation under 500 characters",
  "Every task of this activity is already closed.": "Every task of this activity is already closed.",
  "We could not load this activity's tasks.": "We could not load this activity's tasks.",
  "We could not load who can take this task.": "We could not load who can take this task.",
  "No one else can take this task.": "No one else can take this task.",
  "New owner": "New owner",
  "Change owner": "Change owner",
  "You can't change this task.": "You can't change this task.",
  "This task is no longer available.": "This task is no longer available.",
  "Task cancelled": "Task cancelled",
  "Activity cancelled": "Activity cancelled",
  "Marked as no-show": "Marked as no-show",
  "Task owner changed": "Task owner changed",
  "This task is already closed.": "This task is already closed.",
  "Draft approved": "Draft approved",
  "Drafts approved": "Drafts approved",
  "The diagnosis code list is not available.": "The diagnosis code list is not available.",
  "This AI draft changed. Review it again.": "This AI draft changed. Review it again.",
  "Possible privacy leak": "Possible privacy leak",
  "Possibly made up": "Possibly made up",
  "Scribe reported a problem": "Scribe reported a problem",
  "Whole form": "Whole form",
  "Scribe raised no warnings on this form.": "Scribe raised no warnings on this form.",
  "Approve form": "Approve form",
  "Approve all drafts": "Approve all drafts",
  "AI draft": "AI draft",
  "AI drafts with Scribe": "AI drafts with Scribe",
  "Generate drafts with AI": "Generate drafts with AI",
  "Choose a saved note": "Choose a saved note",
  "Or type notes for Scribe": "Or type notes for Scribe",
  "Generating drafts…": "Generating drafts…",
  "Scribe is taking longer than expected. Check again later.": "Scribe is taking longer than expected. Check again later.",
  "Scribe could not generate drafts.": "Scribe could not generate drafts.",
  "You can't generate drafts for this task.": "You can't generate drafts for this task.",
  "Scribe withheld a draft for: {forms}": "Scribe withheld a draft for: {forms}",
  "AI draft withheld": "AI draft withheld",
  "{n} drafts ready for review": "One draft ready for review | {n} drafts ready for review",
  "Use a saved note": "Use a saved note",
  "You can't use this case's notes.": "You can't use this case's notes.",
  "Generate again": "Generate again",
  "Choose a note": "Choose a note",
  "Review the AI draft before approving": "Review the AI draft before approving",
  "{done} of {total} reviewed": "{done} of {total} reviewed",
  "Save your changes to approve this form.": "Save your changes to approve this form.",
  "Review every warning to approve this form.": "Review every warning to approve this form.",
  "Type at least two characters to search.": "Type at least two characters to search.",
  "Certificate updated": "Certificate updated",
  "The document editor is not available.": "The document editor is not available.",
  "Could not refresh the certificate.": "Could not refresh the certificate.",
  "Update the certificate?": "Update the certificate?",
  "Updating regenerates the certificate with the latest data.": "Updating regenerates the certificate with the latest data.",
  "Sign this certificate from the dossier's Documents tab once the task is completed.": "Sign this certificate from the dossier's Documents tab once the task is completed.",
  "Refresh": "Refresh",
  "Update": "Update",
  "Your edits could not be saved. Try again.": "Your edits could not be saved. Try again.",
  "A document is signed and is the final version.": "A document is signed and is the final version.",
  "Could not refresh the document.": "Could not refresh the document.",
  "Edit document": "Edit document",
  "Stop editing": "Stop editing",
  "Document saved": "Document saved",
  "Leave the document?": "Leave the document?",
  "Edits the editor has not saved yet are lost.": "Edits the editor has not saved yet are lost.",
  "Leave": "Leave",
  "Choose a role": "Choose a role",
  "Add a signature image": "Add a signature image",
  "Keep the notes under 1000 characters": "Keep the notes under 1000 characters",
  "Signature saved": "Signature saved",
  "Signature set as active": "Signature set as active",
  "Signature deleted": "Signature deleted",
  "This signature is no longer available": "This signature is no longer available",
  "Draw your signature": "Draw your signature",
  "Add signature": "Add signature",
  "Edit signature": "Edit signature",
  "Upload an image or draw your signature.": "Upload an image or draw your signature.",
  "We could not load your roles.": "We could not load your roles.",
  "Draw": "Draw",
  "Choose image": "Choose image",
  "PNG, JPEG or WebP, up to 5 MB.": "PNG, JPEG or WebP, up to 5 MB.",
  "Set as active": "Set as active",
  "Signing uses the active signature for this role.": "Signing uses the active signature for this role.",
  "Save signature": "Save signature",
  "No role": "No role",
  "Inactive": "Inactive",
  "Set active": "Set active",
  "Edit {name}": "Edit {name}",
  "Delete {name}": "Delete {name}",
  "Signatures": "Signatures",
  "No signatures yet": "No signatures yet",
  "Add a signature to sign documents for your role.": "Add a signature to sign documents for your role.",
  "Delete this signature?": "Delete this signature?",
  "The signature is deleted. Documents already signed with it keep it.": "The signature is deleted. Documents already signed with it keep it.",
  "Preview unavailable": "Preview unavailable",
  "The active signature is used when you sign a document for that role.": "The active signature is used when you sign a document for that role.",
  "Add signature for {role}": "Add signature for {role}",
  "Used when you sign as {role}": "Used when you sign as {role}",
  "No active signature. You can't sign as {role} until you set one active.": "No active signature. You can't sign as {role} until you set one active.",
  "No signature yet. You can't sign as {role} until you add one.": "No signature yet. You can't sign as {role} until you add one.",
  "Other signatures": "Other signatures",
  "This is the active signature for {role}. You can't sign as {role} until you set another one active.": "This is the active signature for {role}. You can't sign as {role} until you set another one active.",
  "You can't sign this document": "You can't sign this document",
  "Document fully signed": "Document fully signed",
  "Document partially signed. More signatures are still needed.": "Document partially signed. More signatures are still needed.",
  "Sign": "Sign",
  "Sign document": "Sign document",
  "This document requires the {role} signature.": "This document requires the {role} signature.",
  "Awaiting: {types}": "Awaiting: {types}",
  "You have no active signature for {role}.": "You have no active signature for {role}.",
  "You have no active signature.": "You have no active signature.",
  "Manage signatures": "Manage signatures",
  "Choose a signature": "Choose a signature",
  "Could not load this document.": "Could not load this document.",
  "Absence contact": "Absence contact",
  "HSE contact": "HSE contact",
  "Employer main contact": "Employer main contact",
  "Client main contact": "Client main contact",
  "The document could not be signed. Please try again.": "The document could not be signed. Please try again.",
  "{shown} of {total}": "{shown} of {total}",
  "Conclude activity": "Conclude activity",
  "Conclude this activity?": "Conclude this activity?",
  "Conclude": "Conclude",
  "Activity concluded": "Activity concluded",
  "This activity is not invoiced.": "This activity is not invoiced.",
  "We could not check this activity.": "We could not check this activity.",
  "Time spent (minutes)": "Time spent (minutes)",
  "Time spent (minutes, optional)": "Time spent (minutes, optional)",
  "Enter the time spent": "Enter the time spent",
  "Enter whole minutes, at least 1": "Enter whole minutes, at least 1",
  "Amount excl. VAT": "Amount excl. VAT",
  "VAT": "VAT",
  "Total": "Total",
  "Day": "Day",
  "Month": "Month",
  "Previous period": "Previous period",
  "Next period": "Next period",
  "Go to date": "Go to date",
  "No appointments this day": "No appointments this day",
  "No appointments this week": "No appointments this week",
  "No appointments this month": "No appointments this month",
  "Calendar": "Calendar",
  "List": "List",
  "Appointment moved": "Appointment moved",
  "Undo": "Undo",
  "Could not move the appointment.": "Could not move the appointment.",
  "Appointment scheduled": "Appointment scheduled",
  "Pick a time inside your availability.": "Pick a time inside your availability.",
  "This availability has no location, so it cannot be booked here.": "This availability has no location, so it cannot be booked here.",
  "This activity has no task you can book.": "This activity has no task you can book.",
  "Schedule an appointment": "Schedule an appointment",
  "Webshop": "Webshop",
  "Book for": "Book for",
  "Person": "Person",
  "Choose…": "Choose…",
  "Choose an activity": "Choose an activity",
  "Room": "Room",
  "Choose a room": "Choose a room",
  "Signaling date": "Signaling date",
  "Private note": "Private note",
  "Schedule": "Schedule",
  "Yes, delete it": "Yes, delete it",
  "Delete recurring event?": "Delete recurring event?",
  "Event deleted. Click Undo to restore.": "Event deleted. Click Undo to restore.",
  "Event restored.": "Event restored.",
  "Cannot restore: time slot is now taken.": "Cannot restore: time slot is now taken.",
  "Failed to restore event.": "Failed to restore event.",
  "Failed to delete event.": "Failed to delete event.",
  "More actions for {name}": "More actions for {name}",
  "Warning: \"All\" includes past instances as well. Use \"Following\" if you only want future events.": "Warning: \"All\" includes past instances as well. Use \"Following\" if you only want future events.",
  "Are you sure?": "Are you sure?",
  "The whole appointment will be removed, with every task on it.": "The whole appointment will be removed, with every task on it.",
  "You can undo this straight afterwards.": "You can undo this straight afterwards.",
  "Delete appointment and activity list": "Delete appointment and activity list",
  "This appointment created its activity list. Delete the list with it, or keep the list and remove the appointment only.": "This appointment created its activity list. Delete the list with it, or keep the list and remove the appointment only.",
  "Delete appointment only": "Delete appointment only",
  "Recurring events restored.": "Recurring events restored.",
  "Recurring events deleted. Click Undo to restore.": "Recurring events deleted. Click Undo to restore.",
  "This event only": "This event only",
  "Affects only the selected occurrence.": "Affects only the selected occurrence.",
  "This and following events": "This and following events",
  "Affects this event and every future event in the series.": "Affects this event and every future event in the series.",
  "All events in series": "All events in series",
  "Affects every event in the entire series.": "Affects every event in the entire series.",
  "Contacts": "Contacts",
  "The professionals and employer contacts you work with.": "The professionals and employer contacts you work with.",
  "No contacts in your scope": "No contacts in your scope",
  "You don't have access to contacts": "You don't have access to contacts",
  "Type": "Type",
  "Level": "Level",
  "Phone": "Phone",
  "Home": "Home",
  "Private": "Private",
  "Employment": "Employment",
  "Person's department": "Person's department",
  "Person's division": "Person's division",
  "Person's employer": "Person's employer",
  "Person's client": "Person's client",
  "Administrator": "Administrator",
  "Privacy & legal": "Privacy & legal",
  "Privacy Policy": "Privacy Policy",
  "Terms & Conditions": "Terms & Conditions",
  "Status": "Status",
  "Accepted": "Accepted",
  "Awaiting acceptance": "Awaiting acceptance",
  "Accepted on": "Accepted on",
  "Last updated": "Last updated",
  "Version": "Version",
  "Download PDF": "Download PDF",
  "Document not available": "Document not available",
  "Review the document below": "Review the document below",
  "Email communication": "Email communication",
  "Enabled": "Enabled",
  "required": "required",
  "Email communication is essential for the proper functioning of this portal and cannot be disabled.": "Email communication is essential for the proper functioning of this portal and cannot be disabled.",
  "Platform information": "Platform information",
  "This portal is technically provided by InCTRL, acting as a data processor on behalf of {organisation}.": "This portal is technically provided by InCTRL, acting as a data processor on behalf of {organisation}.",
  "the organisation": "the organisation",
  "Confidentiality reminder": "Confidentiality reminder",
  "Do not disclose medical diagnoses or detailed health information through employer-visible channels. Follow role-based access and security procedures.": "Do not disclose medical diagnoses or detailed health information through employer-visible channels. Follow role-based access and security procedures.",
  "A new version is waiting for your acceptance": "A new version is waiting for your acceptance",
  "Below you can review the privacy and legal documents applicable to your use of this Professional Portal, as well as essential communication information.": "Below you can review the privacy and legal documents applicable to your use of this Professional Portal, as well as essential communication information.",
  "You don't have access to this page": "You don't have access to this page",
  "Acceptable use / no misuse": "Acceptable use / no misuse",
  "Access and key actions may be logged for security and audit purposes.": "Access and key actions may be logged for security and audit purposes.",
  "All items must be confirmed to continue": "All items must be confirmed to continue",
  "All set": "All set",
  "Check all": "Check all",
  "Complete the required steps to continue": "Complete the required steps to continue",
  "Confidentiality and restricted access": "Confidentiality and restricted access",
  "Confirm & Start": "Confirm & Start",
  "Continue": "Continue",
  "Data minimization": "Data minimization",
  "Do not disclose medical diagnoses or detailed health information through employer-visible channels": "Do not disclose medical diagnoses or detailed health information through employer-visible channels",
  "Do not misuse the system or access data outside your permissions": "Do not misuse the system or access data outside your permissions",
  "Documents have been updated": "Documents have been updated",
  "Email communication is required for using this portal. We use email to ensure you receive time-sensitive and service-critical information.": "Email communication is required for using this portal. We use email to ensure you receive time-sensitive and service-critical information.",
  "Emails are used for important updates, required actions, appointment changes, security notices, and shared documents.": "Emails are used for important updates, required actions, appointment changes, security notices, and shared documents.",
  "Employer information boundaries": "Employer information boundaries",
  "Essential email communication": "Essential email communication",
  "Essential email communication acknowledged": "Essential email communication acknowledged",
  "Follow role-based access and keep credentials secure": "Follow role-based access and keep credentials secure",
  "I have read and accept the Terms & Conditions of {organization}.": "I have read and accept the Terms & Conditions of {organization}.",
  "I have read and understood the Privacy Policy of {organization}.": "I have read and understood the Privacy Policy of {organization}.",
  "I understand that employer-facing information must remain work-related and must not include medical diagnoses or detailed health information. I will ensure medical details are recorded only in appropriate restricted areas and not disclosed through employer-visible channels.": "I understand that employer-facing information must remain work-related and must not include medical diagnoses or detailed health information. I will ensure medical details are recorded only in appropriate restricted areas and not disclosed through employer-visible channels.",
  "I understand that essential service emails are required to use this portal.": "I understand that essential service emails are required to use this portal.",
  "I understand that key actions may be logged for security and audit. I will keep my account credentials secure and follow applicable security procedures.": "I understand that key actions may be logged for security and audit. I will keep my account credentials secure and follow applicable security procedures.",
  "I understand that the Professional Portal is used to deliver occupational health services and related workflows on behalf of {organization}.": "I understand that the Professional Portal is used to deliver occupational health services and related workflows on behalf of {organization}.",
  "I understand that the portal may contain confidential information, including health-related data, and that access is restricted to authorized professionals based on role and assignment.": "I understand that the portal may contain confidential information, including health-related data, and that access is restricted to authorized professionals based on role and assignment.",
  "I will record and upload only information that is necessary for service delivery and compliant case handling, in line with data minimization principles.": "I will record and upload only information that is necessary for service delivery and compliant case handling, in line with data minimization principles.",
  "I will use the portal only for authorized professional purposes. I will not attempt to access data outside my permissions, share data in unauthorized ways, or otherwise misuse the system.": "I will use the portal only for authorized professional purposes. I will not attempt to access data outside my permissions, share data in unauthorized ways, or otherwise misuse the system.",
  "Key rules at a glance": "Key rules at a glance",
  "Key topics include: purposes and legal bases, categories of data, recipients, retention, security measures, and rights.": "Key topics include: purposes and legal bases, categories of data, recipients, retention, security measures, and rights.",
  "Please confirm the statements below to understand your responsibilities for secure and compliant use of the Professional Portal provided by {organization}.": "Please confirm the statements below to understand your responsibilities for secure and compliant use of the Professional Portal provided by {organization}.",
  "Please review the Privacy Policy of {organization} to understand how personal data is collected, used, shared, and protected.": "Please review the Privacy Policy of {organization} to understand how personal data is collected, used, shared, and protected.",
  "Please review the Terms & Conditions of {organization}, which define permitted use of the portal, confidentiality and security expectations, and service limitations.": "Please review the Terms & Conditions of {organization}, which define permitted use of the portal, confidentiality and security expectations, and service limitations.",
  "Please review the updated documents and confirm your acceptance to continue using the portal.": "Please review the updated documents and confirm your acceptance to continue using the portal.",
  "Privacy & legal confirmations": "Privacy & legal confirmations",
  "Privacy Policy Document": "Privacy Policy Document",
  "Privacy Policy accepted": "Privacy Policy accepted",
  "Professional use & confidentiality acknowledgements": "Professional use & confidentiality acknowledgements",
  "Professional use & confidentiality acknowledgements confirmed": "Professional use & confidentiality acknowledgements confirmed",
  "Purpose and scope": "Purpose and scope",
  "Required acknowledgements": "Required acknowledgements",
  "Required service emails": "Required service emails",
  "Security, credentials and logging": "Security, credentials and logging",
  "Sign Out": "Sign Out",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Step {current} of {total}": "Step {current} of {total}",
  "Steps": "Steps",
  "Summary of Changes": "Summary of Changes",
  "Terms & Conditions Document": "Terms & Conditions Document",
  "Terms & Conditions accepted": "Terms & Conditions accepted",
  "These acknowledgements ensure secure and compliant use of the Professional Portal.": "These acknowledgements ensure secure and compliant use of the Professional Portal.",
  "This document explains how personal data is collected, used, stored, and protected in accordance with GDPR/AVG regulations.": "This document explains how personal data is collected, used, stored, and protected in accordance with GDPR/AVG regulations.",
  "This document outlines the rules for using the Professional Portal, your responsibilities, and service terms.": "This document outlines the rules for using the Professional Portal, your responsibilities, and service terms.",
  "This portal is technically provided by InCTRL, acting as a data processor on behalf of {organization}.": "This portal is technically provided by InCTRL, acting as a data processor on behalf of {organization}.",
  "Uncheck all": "Uncheck all",
  "Use the portal only for authorized professional purposes": "Use the portal only for authorized professional purposes",
  "View Privacy Policy": "View Privacy Policy",
  "View Terms & Conditions": "View Terms & Conditions",
  "Without email communication, the Professional Portal cannot function properly.": "Without email communication, the Professional Portal cannot function properly.",
  "You can review the accepted documents and essential communication details later in your profile.": "You can review the accepted documents and essential communication details later in your profile.",
  "You have successfully completed the required confirmations.": "You have successfully completed the required confirmations.",
  "Your account is linked to {organization}. Before you can access the Professional Portal, please review and confirm the items below. This supports compliant handling of confidential information and secure use of the portal.": "Your account is linked to {organization}. Before you can access the Professional Portal, please review and confirm the items below. This supports compliant handling of confidential information and secure use of the portal.",
  "Acknowledgements": "Acknowledgements",
  "Terms": "Terms",
  "Complete": "Complete",
  "We couldn't load the Privacy Policy.": "We couldn't load the Privacy Policy.",
  "We couldn't load the Terms & Conditions.": "We couldn't load the Terms & Conditions.",
  "Support": "Support",
  "New ticket": "New ticket",
  "Subject": "Subject",
  "Description": "Description",
  "Attachments": "Attachments",
  "Add files": "Add files",
  "Reply": "Reply",
  "Send": "Send",
  "You": "You",
  "Support team": "Support team",
  "No tickets yet": "No tickets yet",
  "Select a ticket": "Select a ticket",
  "Pending": "Pending",
  "In progress": "In progress",
  "Resolved": "Resolved",
  "Don't include employee names or medical details.": "Don't include employee names or medical details.",
  "Support is unavailable right now.": "Support is unavailable right now.",
  "Up to 5 files, 10 MB each.": "Up to 5 files, 10 MB each.",
  "All statuses": "All statuses",
  "Ask your administrator to connect the support service.": "Ask your administrator to connect the support service.",
  "Create ticket": "Create ticket",
  "Describe the problem": "Describe the problem",
  "Discard this ticket?": "Discard this ticket?",
  "Discard your reply?": "Discard your reply?",
  "Enter a subject": "Enter a subject",
  "Its messages and your replies appear here.": "Its messages and your replies appear here.",
  "Keep the subject under 500 characters": "Keep the subject under 500 characters",
  "No replies yet": "No replies yet",
  "Priority": "Priority",
  "Remove {name}": "Remove {name}",
  "Reply sent": "Reply sent",
  "Search tickets…": "Search tickets…",
  "Support is not configured": "Support is not configured",
  "Ticket created": "Ticket created",
  "Ticket not found": "Ticket not found",
  "Tickets you create appear here.": "Tickets you create appear here.",
  "What you wrote is not saved.": "What you wrote is not saved.",
  "Write a reply": "Write a reply",
  "You can add up to 5 files.": "You can add up to 5 files.",
  "{name} is larger than 10 MB.": "{name} is larger than 10 MB.",
  "{name} is not a supported file type.": "{name} is not a supported file type.",
  "Low": "Low",
  "Medium": "Medium",
  "High": "High",
  "Urgent": "Urgent",
  "Sign-in": "Sign-in",
  "Bug": "Bug",
  "Feature request": "Feature request",
  "Question": "Question",
  "Mark all as read": "Mark all as read",
  "View all notifications": "View all notifications",
  "No notifications yet": "No notifications yet",
  "Nothing unread": "Nothing unread",
  "Unread": "Unread",
  "All": "All",
  "This notification has no further details.": "This notification has no further details.",
  "Open related record": "Open related record",
  "Opens in the previous portal": "Opens in the previous portal",
  "You don't have access to notifications": "You don't have access to notifications",
  "Search notifications…": "Search notifications…",
  "Select a notification": "Select a notification",
  "Notification not found": "Notification not found",
  "Someone": "Someone",
  "the subject": "the subject",
  "Current absences": "Current absences",
  "Everyone absent today across your organisations.": "Everyone absent today across your organisations.",
  "Absences in the chosen period, this calendar year by default.": "Absences in the chosen period, this calendar year by default.",
  "Search by name or employer…": "Search by name or employer…",
  "No one is absent right now": "No one is absent right now",
  "No absences in this period": "No absences in this period",
  "You don't have access to current absences": "You don't have access to current absences",
  "History": "History",
  "Percentage": "Percentage",
  "Since": "Since",
  "Days this year": "Days this year",
  "Days in period": "Days in period",
  "Leave empty for this calendar year.": "Leave empty for this calendar year.",
  "Choose a division first": "Choose a division first",
  "The end date must be on or after the start date": "The end date must be on or after the start date",
  "Medical": "Medical",
  "Training": "Training",
  "Review": "Review",
  "Message": "Message",
  "Change": "Change",
  "Any type": "Any type",
  "Events across your scope appear here.": "Events across your scope appear here.",
  "Date": "Date",
  "Select a person": "Select a person",
  "Choose a department first": "Choose a department first",
  "Search persons…": "Search persons…",
  "Search the timeline…": "Search the timeline…",
  "Every event across your scope, newest first.": "Every event across your scope, newest first.",
  "You don't have access to the timeline": "You don't have access to the timeline",
  "The end date must be on or after the start date.": "The end date must be on or after the start date.",
  "An organisation filter shows events about that organisation itself, not about the people in it.": "An organisation filter shows events about that organisation itself, not about the people in it.",
  "Linked to": "Linked to",
  "Final": "Final",
  "Approved": "Approved",
  "Expired": "Expired",
  "Any status": "Any status",
  "Awaiting my signature": "Awaiting my signature",
  "Every document across your scope, newest first.": "Every document across your scope, newest first.",
  "Matches document names and their text.": "Matches document names and their text.",
  "Search documents…": "Search documents…",
  "Documents you may see appear here.": "Documents you may see appear here.",
  "You don't have access to documents": "You don't have access to documents",
  "Messages": "Messages",
  "Edited": "Edited",
  "Message deleted": "Message deleted",
  "You don't have access to this document": "You don't have access to this document",
  "Internal": "Internal",
  "External": "External",
  "Archived": "Archived",
  "Conversation updated": "Conversation updated",
  "{name} added a participant": "{name} added a participant",
  "{name} removed a participant": "{name} removed a participant",
  "{name} left the conversation": "{name} left the conversation",
  "{name} renamed the conversation": "{name} renamed the conversation",
  "{name} archived the conversation": "{name} archived the conversation",
  "{name} resolved the conversation": "{name} resolved the conversation",
  "{names} is typing…": "{names} is typing…",
  "Channel": "Channel",
  "All channels": "All channels",
  "Unread shows open conversations only.": "Unread shows open conversations only.",
  "Messaging is being rolled out. Try again later.": "Messaging is being rolled out. Try again later.",
  "Accept the terms first": "Accept the terms first",
  "Search topics…": "Search topics…",
  "No conversations yet": "No conversations yet",
  "No topic": "No topic",
  "{count} unread": "{count} unread",
  "Pick a conversation": "Pick a conversation",
  "This conversation isn't available": "This conversation isn't available",
  "{count} participant | {count} participants": "{count} participant | {count} participants",
  "Authorized contact": "Authorized contact",
  "Partner information": "Partner information",
  "Actions for {name}": "Actions for {name}",
  "Edit details": "Edit details",
  "File access": "File access",
  "Add activity": "Add activity",
  "Add person": "Add person",
  "Person added": "Person added",
  "Leave it empty, or fill in every field marked *.": "Leave it empty, or fill in every field marked *.",
  "Choose a language": "Choose a language",
  "Choose a client": "Choose a client",
  "Choose an employer": "Choose an employer",
  "Choose a division": "Choose a division",
  "Choose a department": "Choose a department",
  "Enter a contact number": "Enter a contact number",
  "Choose a job title": "Choose a job title",
  "Choose a contract type": "Choose a contract type",
  "Enter the hours": "Enter the hours",
  "Enter a percentage from 0 to 100": "Enter a percentage from 0 to 100",
  "Start before the end date": "Start before the end date",
  "Enter the last name": "Enter the last name",
  "Use at least 2 characters": "Use at least 2 characters",
  "Choose the date of birth": "Choose the date of birth",
  "Use at most 40 characters": "Use at most 40 characters",
  "Use at most 5000 characters": "Use at most 5000 characters",
  "Postal country": "Postal country",
  "External key": "External key",
  "Cost center": "Cost center",
  "Nationality": "Nationality",
  "Phone number": "Phone number",
  "Preferred language": "Preferred language",
  "Language": "Language",
  "Job title": "Job title",
  "Start date": "Start date",
  "Hours per week": "Hours per week",
  "Part-time percentage": "Part-time percentage",
  "Changes saved": "Changes saved",
  "Home phone": "Home phone",
  "Private phone": "Private phone",
  "Business email": "Business email",
  "Insurance": "Insurance",
  "Insurance company": "Insurance company",
  "Policy number": "Policy number",
  "You don't have access to this person": "You don't have access to this person",
  "Add employment": "Add employment",
  "Edit employment": "Edit employment",
  "Employment added": "Employment added",
  "Employment updated": "Employment updated",
  "Employment deleted": "Employment deleted",
  "Delete employment?": "Delete employment?",
  "This cannot be undone.": "This cannot be undone.",
  "Choose a supervisor": "Choose a supervisor",
  "Choose an absence contact person": "Choose an absence contact person",
  "No one has opened this file yet": "No one has opened this file yet",
  "When": "When",
  "Who": "Who",
  "Action": "Action",
  "Activity type": "Activity type",
  "No activities available": "No activities available",
  "Due date": "Due date",
  "Due time": "Due time",
  "Alert date": "Alert date",
  "Duration in minutes": "Duration in minutes",
  "Activity order number": "Activity order number",
  "This activity has no tasks.": "This activity has no tasks.",
  "Choose a task owner": "Choose a task owner",
  "No task owner available": "No task owner available",
  "Assign activity": "Assign activity",
  "Enter the duration in whole minutes": "Enter the duration in whole minutes",
  "Choose a due date": "Choose a due date",
  "Choose an alert date": "Choose an alert date",
  "Activity assigned Successfully!": "Activity assigned Successfully!",
  "Activity assigned — it will be scheduled automatically.": "Activity assigned — it will be scheduled automatically.",
  "Created": "Created",
  "Updated": "Updated",
  "Changed": "Changed",
  "Organisations": "Organisations",
  "Your organisations": "Your organisations",
  "This organisation isn't available": "This organisation isn't available",
  "Nothing below this level": "Nothing below this level",
  "Expand": "Expand",
  "Collapse": "Collapse",
  "Absent today": "Absent today",
  "Open in organisation": "Open in organisation",
  "Open in Clients": "Open in Clients",
  "Open in Employers": "Open in Employers",
  "Open in Divisions": "Open in Divisions",
  "Open in Departments": "Open in Departments",
  "No organisations to show": "No organisations to show",
  "Your access does not start at an organisation.": "Your access does not start at an organisation.",
  "Events recorded for this organisation appear here.": "Events recorded for this organisation appear here.",
  "You don't have access to this timeline": "You don't have access to this timeline",
  "No persons in this organisation": "No persons in this organisation",
  "Documents filed for this organisation appear here.": "Documents filed for this organisation appear here.",
  "You don't have access to this organisation's documents": "You don't have access to this organisation's documents",
  "You don't have access to these organisations": "You don't have access to these organisations",
  "Choose an organisation to open it.": "Choose an organisation to open it.",
  "Delete this message?": "Delete this message?",
  "Write a message…": "Write a message…",
  "No one to mention": "No one to mention",
  "Mention": "Mention",
  "This conversation is closed for new messages.": "This conversation is closed for new messages.",
  "You follow this conversation as an observer.": "You follow this conversation as an observer.",
  "You can't post in this conversation.": "You can't post in this conversation.",
  "This message is too long.": "This message is too long.",
  "This message can no longer be edited.": "This message can no longer be edited.",
  "Your changes weren't saved. Try again.": "Your changes weren't saved. Try again.",
  "Couldn't delete this message.": "Couldn't delete this message.",
  "Your message wasn't sent. Try again.": "Your message wasn't sent. Try again.",
  "The message is replaced by “Message deleted” for everyone.": "The message is replaced by “Message deleted” for everyone.",
  "Discard your message?": "Discard your message?",
  "Employer contacts can read this conversation. Don't include medical details.": "Employer contacts can read this conversation. Don't include medical details.",
  "About": "About",
  "Add participant": "Add participant",
  "Archive": "Archive",
  "Archive conversation?": "Archive conversation?",
  "Discard this conversation?": "Discard this conversation?",
  "First message (optional)": "First message (optional)",
  "Leave conversation": "Leave conversation",
  "Leave this conversation?": "Leave this conversation?",
  "Left": "Left",
  "Member": "Member",
  "New conversation": "New conversation",
  "Observer": "Observer",
  "Owner": "Owner",
  "Participants": "Participants",
  "Pick who this conversation is about first": "Pick who this conversation is about first",
  "Remove {name}?": "Remove {name}?",
  "Rename": "Rename",
  "Reopen": "Reopen",
  "Resolve": "Resolve",
  "Resolve conversation?": "Resolve conversation?",
  "Search participants…": "Search participants…",
  "Search people…": "Search people…",
  "Start conversation": "Start conversation",
  "The conversation couldn't be created. Try again.": "The conversation couldn't be created. Try again.",
  "The conversation couldn't be renamed. Try again.": "The conversation couldn't be renamed. Try again.",
  "The conversation leaves everyone's open list. You can find it under Archived.": "The conversation leaves everyone's open list. You can find it under Archived.",
  "The conversation leaves everyone's open list. You can find it under Resolved.": "The conversation leaves everyone's open list. You can find it under Resolved.",
  "They lose access to this conversation.": "They lose access to this conversation.",
  "Topic": "Topic",
  "You can't change this conversation.": "You can't change this conversation.",
  "You lose access to it and it leaves your inbox.": "You lose access to it and it leaves your inbox.",
  "Couldn't update the conversation. Try again.": "Couldn't update the conversation. Try again.",
  "This organisation's action list isn't available": "This organisation's action list isn't available",
  "No open items for this organisation": "No open items for this organisation",
  "Open in Action list": "Open in Action list",
  "{count} document couldn't be attached | {count} documents couldn't be attached": "{count} document couldn't be attached | {count} documents couldn't be attached",
  "Attach documents": "Attach documents",
  "Attach ({count})": "Attach ({count})",
  "Maximum 10 documents": "Maximum 10 documents",
  "Search a document…": "Search a document…",
  "No documents found": "No documents found",
  "You don't have access to these documents": "You don't have access to these documents",
  "Attached documents": "Attached documents",
  "Choose up to 10 documents to send with your message": "Choose up to 10 documents to send with your message",
  "No appointments in this period": "No appointments in this period",
  "Range": "Range",
  "Up to 42 days are shown": "Up to 42 days are shown",
  "{hours}h {minutes}m": "{hours}h {minutes}m",
  "{minutes}m": "{minutes}m",
  "Planned": "Planned",
  "No appointments with this status": "No appointments with this status",
  "The end date is before the start date, so one day is shown": "The end date is before the start date, so one day is shown",
  "Could not save the colour.": "Could not save the colour.",
  "Agenda settings": "Agenda settings",
  "Time scale": "Time scale",
  "10 minutes": "10 minutes",
  "5 minutes": "5 minutes",
  "Status colours": "Status colours",
  "Reset": "Reset",
  "Recurring": "Recurring",
  "Open dossier": "Open dossier",
  "This week": "This week",
  "List view": "List view",
  "Print": "Print",
  "Blocked": "Blocked",
  "Blocked · {time}": "Blocked · {time}",
  "Blocked · all day": "Blocked · all day",
  "Export": "Export",
  "Export PDF": "Export PDF",
  "Export Excel": "Export Excel",
  "Export CSV": "Export CSV",
  "Export .ics": "Export .ics",
  "Export to calendar": "Export to calendar",
  "Export failed": "Export failed",
  "Could not download .ics file": "Could not download .ics file",
  "Select all ({selected}/{total})": "Select all ({selected}/{total})",
  "Cancel selected appointments?": "Cancel selected appointments?",
  "This cancels {count} appointment. | This cancels {count} appointments.": "This cancels {count} appointment. | This cancels {count} appointments.",
  "Cancel appointments": "Cancel appointments",
  "Keep them": "Keep them",
  "Reason (required)": "Reason (required)",
  "Why are these being cancelled?": "Why are these being cancelled?",
  "{count} done, {failed} failed": "{count} done, {failed} failed",
  "Bulk cancel is not available": "Bulk cancel is not available",
  "Bulk action failed": "Bulk action failed",
  "Select {name}": "Select {name}",
  "Select appointment": "Select appointment",
  "No appointments for recovered persons": "No appointments for recovered persons",
  "Me": "Me",
  "Taken": "Taken",
  "Outside availability": "Outside availability",
  "Repeat": "Repeat",
  "Never": "Never",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Monthly": "Monthly",
  "Yearly": "Yearly",
  "Repeat ends": "Repeat ends",
  "A number of times": "A number of times",
  "Until a date": "Until a date",
  "Number of times": "Number of times",
  "Repeat until": "Repeat until",
  "The professionals for this slot could not be loaded.": "The professionals for this slot could not be loaded.",
  "Recurring events moved.": "Recurring events moved.",
  "Move recurring event?": "Move recurring event?",
  "The event you moved takes the new day. The others keep their own day and take the new time.": "The event you moved takes the new day. The others keep their own day and take the new time.",
  "Move": "Move",
  "Availabilities": "Availabilities",
  "Calendars": "Calendars",
  "Search calendars…": "Search calendars…",
  "No calendars to manage": "No calendars to manage",
  "Calendars you manage appear here.": "Calendars you manage appear here.",
  "You don't have access to availabilities": "You don't have access to availabilities",
  "Choose a calendar": "Choose a calendar",
  "A colleague's availability appears here.": "A colleague's availability appears here.",
  "This calendar isn't available": "This calendar isn't available",
  "Types": "Types",
  "Availability added": "Availability added",
  "Availability saved": "Availability saved",
  "Availability removed": "Availability removed",
  "This availability is no longer available": "This availability is no longer available",
  "We could not remove this availability.": "We could not remove this availability.",
  "Enter a title": "Enter a title",
  "Choose a date": "Choose a date",
  "End after the start time": "End after the start time",
  "Choose an end date": "Choose an end date",
  "End on or after the start date": "End on or after the start date",
  "Choose at least one day": "Choose at least one day",
  "Choose a location": "Choose a location",
  "Add availability": "Add availability",
  "Edit availability": "Edit availability",
  "When this colleague can be booked, or is away.": "When this colleague can be booked, or is away.",
  "Repeats weekly": "Repeats weekly",
  "Until": "Until",
  "Start time": "Start time",
  "End time": "End time",
  "Location": "Location",
  "Save anyway?": "Save anyway?",
  "Save anyway": "Save anyway",
  "This day": "This day",
  "The whole series": "The whole series",
  "This day and following": "This day and following",
  "Which days do you want to remove?": "Which days do you want to remove?",
  "Remove this availability?": "Remove this availability?",
  "This time has bookings": "This time has bookings",
  "On these days": "On these days",
  "Weekdays": "Weekdays",
  "Weekends": "Weekends",
  "Every day": "Every day",
  "It is taken off this colleague’s calendar.": "It is taken off this colleague’s calendar.",
  "This appointment is being edited by someone else. Please try again shortly.": "This appointment is being edited by someone else. Please try again shortly.",
  "This appointment was changed elsewhere. The agenda has been reloaded.": "This appointment was changed elsewhere. The agenda has been reloaded.",
  "Could not open the appointment.": "Could not open the appointment.",
  "Appointment updated": "Appointment updated",
  "You can no longer edit this appointment.": "You can no longer edit this appointment.",
  "The signaling date may not be after the appointment date.": "The signaling date may not be after the appointment date.",
  "Edit appointment": "Edit appointment",
  "Your hold on this appointment has ended. Someone else may change it now.": "Your hold on this appointment has ended. Someone else may change it now.",
  "Time": "Time",
  "Save changes": "Save changes",
  "Being edited by someone else": "Being edited by someone else",
  "Edit this day": "Edit this day",
  "Which days do you want to edit?": "Which days do you want to edit?",
  "Edit from this day": "Edit from this day",
  "From {date} onwards. Earlier days stay as they are.": "From {date} onwards. Earlier days stay as they are.",
  "Only {date} changes. The rest of the series stays as it is.": "Only {date} changes. The rest of the series stays as it is.",
  "Busy": "Busy",
  "Busy · {name}": "Busy · {name}",
  "You no longer manage {name}'s calendar": "You no longer manage {name}'s calendar",
  "Up to two colleagues": "Up to two colleagues",
  "All rooms": "All rooms",
  "My calendar": "My calendar",
  "No appointments at this location": "No appointments at this location",
  "Whose calendar": "Whose calendar",
  "Only for these clients": "Only for these clients",
  "Choose clients": "Choose clients",
  "Search clients": "Search clients",
  "No clients to choose from": "No clients to choose from",
  "Choose at least one client": "Choose at least one client",
  "Only for {clients}": "Only for {clients}",
  "Custom colours": "Custom colours",
  "Background": "Background",
  "Text": "Text",
  "Preview": "Preview",
  "Choose a colour": "Choose a colour",
  "Pick a text colour that stands out from the background": "Pick a text colour that stands out from the background",
  "Signed in as {name}": "Signed in as {name}",
  "Not you?": "Not you?",
  "Signing out…": "Signing out…",
  "{client} wants to access your inCTRL account": "{client} wants to access your inCTRL account",
  "Read your workbench, caseload and action list": "Read your workbench, caseload and action list",
  "Read case overviews, timelines, employments and consultation notes you may see": "Read case overviews, timelines, employments and consultation notes you may see",
  "Read your agenda": "Read your agenda",
  "It can't change anything, download documents, or see absence records.": "It can't change anything, download documents, or see absence records.",
  "Access lasts {days} days. Revoke any time in Settings > Connected apps.": "Access lasts {days} days. Revoke any time in Settings > Connected apps.",
  "Allow access": "Allow access",
  "Deny": "Deny",
  "Approving…": "Approving…",
  "Accept the updated terms first": "Accept the updated terms first",
  "inCTRL needs you to accept the updated terms before you can connect an app.": "inCTRL needs you to accept the updated terms before you can connect an app.",
  "Open inCTRL": "Open inCTRL",
  "I've accepted, continue": "I've accepted, continue",
  "Terms still need accepting in inCTRL.": "Terms still need accepting in inCTRL.",
  "Too many connected apps": "Too many connected apps",
  "You have 20 connected apps. Revoke one in Settings first.": "You have 20 connected apps. Revoke one in Settings first.",
  "Open Settings": "Open Settings",
  "This request expired": "This request expired",
  "Go back to {client} and connect again.": "Go back to {client} and connect again.",
  "Go back to the app you were connecting and connect again.": "Go back to the app you were connecting and connect again.",
  "This link was already used": "This link was already used",
  "If the app you were connecting shows inCTRL as connected, you're done. Otherwise go back and connect again.": "If the app you were connecting shows inCTRL as connected, you're done. Otherwise go back and connect again.",
  "This link expired": "This link expired",
  "Approved. Returning you to {client}…": "Approved. Returning you to {client}…",
  "You denied access. Returning you to {client}…": "You denied access. Returning you to {client}…",
  "Continue to {client}": "Continue to {client}",
  "You can close this tab.": "You can close this tab.",
  "This connection didn't finish": "This connection didn't finish",
  "Go back to {client} and connect again. Nothing was connected.": "Go back to {client} and connect again. Nothing was connected.",
  "inCTRL can't be reached. Try again.": "inCTRL can't be reached. Try again.",
  "Connect an AI assistant": "Connect an AI assistant",
  "Request expires in {minutes} min": "Request expires in {minutes} min",
  "Request expires in less than a minute": "Request expires in less than a minute",
  "1 minute left": "1 minute left",
  "Connected apps": "Connected apps",
  "AI assistants that can read your inCTRL data.": "AI assistants that can read your inCTRL data.",
  "No connected apps.": "No connected apps.",
  "When you connect an AI assistant, it shows up here.": "When you connect an AI assistant, it shows up here.",
  "Connected {date}": "Connected {date}",
  "Last used {when}": "Last used {when}",
  "Not used yet": "Not used yet",
  "Expires {date}": "Expires {date}",
  "Revoke": "Revoke",
  "Revoke {name}?": "Revoke {name}?",
  "It loses access right away. You can connect it again later.": "It loses access right away. You can connect it again later.",
  "This app was already disconnected.": "This app was already disconnected.",
  "We could not revoke this app. Please try again.": "We could not revoke this app. Please try again.",
  "Find a slot": "Find a slot",
  "Slots ranked by how well they fit, best first.": "Slots ranked by how well they fit, best first.",
  "Slots": "Slots",
  "Who is it for?": "Who is it for?",
  "Activities from": "Activities from",
  "Select an activity": "Select an activity",
  "Select a location": "Select a location",
  "Not on the contract": "Not on the contract",
  "Contract is not active": "Contract is not active",
  "Not available": "Not available",
  "Time of day": "Time of day",
  "Any time": "Any time",
  "Evening": "Evening",
  "Find slots": "Find slots",
  "Choose who the appointment is for and what it is, then find slots.": "Choose who the appointment is for and what it is, then find slots.",
  "No available slots found. Try another time of day or activity.": "No available slots found. Try another time of day or activity.",
  "Smart scheduling is not available": "Smart scheduling is not available",
  "It may not be enabled for your organisation, or you may no longer have access to this person or organisation.": "It may not be enabled for your organisation, or you may no longer have access to this person or organisation.",
  "This time slot is no longer available. The list has been refreshed.": "This time slot is no longer available. The list has been refreshed.",
  "Fit {score}": "Fit {score}",
  "Fit": "Fit",
  "Why this slot?": "Why this slot?",
  "Continuity": "Continuity",
  "Adjacency": "Adjacency",
  "Time preference": "Time preference",
  "Advance notice": "Advance notice",
  "Date urgency": "Date urgency",
  "Time band completion": "Time band completion",
  "Day fill": "Day fill",
  "Preference match": "Preference match",
  "Choose": "Choose",
  "This slot no longer has a professional for every task. Pick another slot.": "This slot no longer has a professional for every task. Pick another slot.",
  "Delegated": "Delegated",
  "OHP instead": "OHP instead",
  "the OHP": "the OHP",
  "{task} is carried out by {professional} under task delegation from {ohp}.": "{task} is carried out by {professional} under task delegation from {ohp}.",
  "{task} is carried out by {professional}.": "{task} is carried out by {professional}.",
  "{delegate} holds a task delegation but {reason}.": "{delegate} holds a task delegation but {reason}.",
  "has no availability at this time": "has no availability at this time",
  "is already booked at this time": "is already booked at this time",
  "is not authorised for this person or organisation": "is not authorised for this person or organisation",
  "their task delegation is no longer valid": "their task delegation is no longer valid",
  "is already performing another task in this slot": "is already performing another task in this slot",
  "cannot take it": "cannot take it",
  "Confirm appointment": "Confirm appointment",
  "The slot is held for you for 15 minutes.": "The slot is held for you for 15 minutes.",
  "Book appointment": "Book appointment",
  "Appointment booked": "Appointment booked",
  "Booked: {date} at {time} with {names}": "Booked: {date} at {time} with {names}",
  "Open in agenda": "Open in agenda",
  "Find another slot": "Find another slot",
  "Scheduling preferences": "Scheduling preferences",
  "How Find a slot ranks suggestions for you.": "How Find a slot ranks suggestions for you.",
  "Focus": "Focus",
  "When you prefer concentrated blocks of appointments.": "When you prefer concentrated blocks of appointments.",
  "No preference": "No preference",
  "Location anchor": "Location anchor",
  "Where appointments are placed relative to your base location.": "Where appointments are placed relative to your base location.",
  "Home base": "Home base",
  "Nearest to the person": "Nearest to the person",
  "Max daily gap (minutes)": "Max daily gap (minutes)",
  "Total gap between appointments in a day. Lower is tighter.": "Total gap between appointments in a day. Lower is tighter.",
  "Travel buffer (minutes)": "Travel buffer (minutes)",
  "Minimum time between appointments at different locations.": "Minimum time between appointments at different locations.",
  "Save preferences": "Save preferences",
  "Scheduling preferences saved": "Scheduling preferences saved",
  "We could not load your scheduling preferences. Please try again.": "We could not load your scheduling preferences. Please try again.",
  "We could not save your scheduling preferences. Please try again.": "We could not save your scheduling preferences. Please try again.",
  "Enter a whole number of minutes from 0 to 480": "Enter a whole number of minutes from 0 to 480",
  "Enter a whole number of minutes from 0 to 120": "Enter a whole number of minutes from 0 to 120",
  "Choose another": "Choose another",
  "{name} has joined the video call": "{name} has joined the video call",
  "Join": "Join",
  "The call could not be started. Try again.": "The call could not be started. Try again.",
  "The appointment could not be concluded. Try again.": "The appointment could not be concluded. Try again.",
  "Allow camera and microphone in your browser, then try again.": "Allow camera and microphone in your browser, then try again.",
  "Your camera or microphone could not be started. Check that no other app is using it, then try again.": "Your camera or microphone could not be started. Check that no other app is using it, then try again.",
  "Could not connect to the call. Check your connection, then try again.": "Could not connect to the call. Check your connection, then try again.",
  "The video service is not available right now.": "The video service is not available right now.",
  "The call was disconnected.": "The call was disconnected.",
  "Camera {n}": "Camera {n}",
  "Microphone {n}": "Microphone {n}",
  "No camera or microphone was found. Connect one, then try again.": "No camera or microphone was found. Connect one, then try again.",
  "Your camera or microphone is in use by another app. Close it, then try again.": "Your camera or microphone is in use by another app. Close it, then try again.",
  "The camera or microphone could not be started. Try again.": "The camera or microphone could not be started. Try again.",
  "Check your camera and microphone": "Check your camera and microphone",
  "Camera": "Camera",
  "Microphone": "Microphone",
  "Speak to test your microphone": "Speak to test your microphone",
  "Excellent": "Excellent",
  "Good": "Good",
  "Poor": "Poor",
  "Lost": "Lost",
  "Camera off": "Camera off",
  "Connecting…": "Connecting…",
  "Connection lost. Trying to reconnect…": "Connection lost. Trying to reconnect…",
  "Share screen": "Share screen",
  "Leave the call": "Leave the call",
  "Conclude the appointment": "Conclude the appointment",
  "Waiting for the person to join": "Waiting for the person to join",
  "You’re connected. The person appears here when they join.": "You’re connected. The person appears here when they join.",
  "This appointment’s time window has passed": "This appointment’s time window has passed",
  "This appointment is concluded": "This appointment is concluded",
  "This video call is not available": "This video call is not available",
  "Video consult": "Video consult",
  "{title} with {name}": "{title} with {name}",
  "Video call with {name}": "Video call with {name}",
  "Open My caseload": "Open My caseload",
  "Rejoin": "Rejoin",
  "Back to agenda": "Back to agenda",
  "Leave the call?": "Leave the call?",
  "The appointment stays open. You can rejoin until you conclude it.": "The appointment stays open. You can rejoin until you conclude it.",
  "Conclude the appointment?": "Conclude the appointment?",
  "This ends the call for you and the person, and concludes the appointment. You can’t undo this.": "This ends the call for you and the person, and concludes the appointment. You can’t undo this.",
  "Open the appointment from your agenda.": "Open the appointment from your agenda.",
  "The person may be waiting": "The person may be waiting",
  "You can start the call in {count} minute | You can start the call in {count} minutes": "You can start the call in {count} minute | You can start the call in {count} minutes",
  "The call has started.": "The call has started.",
  "Start the call": "Start the call",
  "Rejoin the call": "Rejoin the call",
  "Start video call": "Start video call",
  "Call ended": "Call ended",
  "Back to organisations": "Back to organisations",
  "No preview for this file type": "No preview for this file type",
  "This document is not available": "This document is not available",
  "We could not load this document.": "We could not load this document."
}
